
import React from "react";
import AudioUpload from "../../../AudioUpload";
// import { CustomButton } from "../../../CustomButtom";
import ImageUpload from "../../../ImageUpload";
// const type = [
//   "none",
//   "text",
//   "image",
//   "audio"
// ]
const type = [
  { name: "Tidak ada", value: "none" },
  { name: "Teks", value: "text" },
  { name: "Gambar", value: "image" },
  { name: "Audio", value: "audio" },
]
const CustomButton = ({ DataValue, setData, Data }) => {
  return (
    <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}
      onClick={() => {
        setData(DataValue.value)
      }}
    >
      <div className={Data == DataValue.value ? "active-option" : "passive-option"}>
        {DataValue.name}
      </div>
    </button>
  )
}
const correctAnswerArray = [
  { name: "Pilihan 1 ", value: "option 1" },
  { name: "Pilihan 2 ", value: "option 2" },
  { name: "Pilihan 3 ", value: "option 3" },
  { name: "Pilihan 4 ", value: "option 4" },

]
const OptionView = ({
  type,
  Data,
  setData,
  placeholderValue,
  que
}) => {
  return (
    <div>
      {(type == "text" || type == "choose_correct") &&
        <>
          {que ?
            <textarea rows={5}
              className="p-0 px-2 col-12"
              value={Data}
              onChange={(event) => { setData(event.target.value) }}
              placeholder={placeholderValue}
            />
            :
            <input
              className="p-0 px-2 col-12"
              value={Data}
              onChange={(event) => { setData(event.target.value) }}
              placeholder={placeholderValue}
            />
          }
        </>
      }
      {
        type == "image" &&
        <>
          <ImageUpload
            ImageUrl={Data}
            setImageUrl={setData}
          />
          {/* <a style={{ color: "#000" }} href={Data} target="_blank">{Data}</a> */}
        </>
      }
      {
        type == "audio" &&
        <>
          <AudioUpload
            ImageUrl={Data}
            setImageUrl={setData}
          />
          {/* <a style={{ color: "#000" }} href={Data} target="_blank">{Data}</a> */}
        </>
      }
    </div>
  )
}
export default function ExamQuestionModal(props) {
  const {
    oneQuestionData,
    keyValue,
    AllQuestionData,
    setAllQuestionData,
    PostExam,
    setEditQuestion
  } = props;

  const [question, setQuestion] = React.useState(oneQuestionData.question)
  const [questionDescription, setQuestionDescription] = React.useState(oneQuestionData.question_description)
  const [option1, setOption1] = React.useState(oneQuestionData.option_1)
  const [option2, setOption2] = React.useState(oneQuestionData.option_2)
  const [option3, setOption3] = React.useState(oneQuestionData.option_3)
  const [option4, setOption4] = React.useState(oneQuestionData.option_4)
  const [answerDescription, setAnswerDescription] = React.useState(oneQuestionData.answer_description)
  const [correctAnswer, setCorrectAnswer] = React.useState(oneQuestionData.correct_answer)
  const [questionMedia, setQuestionMedia] = React.useState(oneQuestionData.question_media)
  const [questionDescriptionType, setQuestionDescriptionType] = React.useState(oneQuestionData.question_description_type)
  const [questionMediaType, setQuestionMediaType] = React.useState(oneQuestionData.question_media_type)
  const [answerMediaType, setAnswerMediaType] = React.useState(oneQuestionData.answer_media_type)

  const [questionNumber, setQuestionNumber] = React.useState(oneQuestionData.question_number)
  const [option1Text, setOption1Text] = React.useState(oneQuestionData.option_1_text == undefined ? "" : oneQuestionData.option_1_text)
  const [option2Text, setOption2Text] = React.useState(oneQuestionData.option_2_text == undefined ? "" : oneQuestionData.option_2_text)
  const [option3Text, setOption3Text] = React.useState(oneQuestionData.option_3_text == undefined ? "" : oneQuestionData.option_3_text)
  const [option4Text, setOption4Text] = React.useState(oneQuestionData.option_4_text == undefined ? "" : oneQuestionData.option_4_text)

  return (
    <div>
      <table>
        <tr>
          {/* <td className="col-4"><b>Question Number : </b></td> */}
          <td className="col-4"><b>Nomor Pertanyaan : </b></td>
          <td className="col-7">
            {/* <input
              className="p-0 px-2 col-12"
              type="text"
              value={question}
              onChange={(event) => { setQuestion(event.target.value) }}
              placeholder="Question"
              required
            /> */}
            {oneQuestionData.question_number}
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Question : </b></td> */}
          <td className="col-4"><b>Pertanyaan : </b></td>
          <td className="col-7">
            <input
              className="p-0 px-2 col-12"
              value={question}
              onChange={(event) => { setQuestion(event.target.value) }}
              placeholder="Question"
            />
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Question Description: </b></td> */}
          <td className="col-4"><b>Deskripsi Pertanyaan: </b></td>
          <td className="col-7">
            <OptionView
              type={questionDescriptionType} que={true}
              Data={questionDescription}
              setData={setQuestionDescription}
              placeholderValue={"Question Description"}
            />
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Question Description Type: </b></td> */}
          <td className="col-4"><b> Tipe Deskripsi Pertanyaan: </b></td>
          <td className="col-7">
            <div style={{ display: "inline" }}>
              {type.map((item, index) => (
                <div style={{ display: "inline-block" }} key={index}>
                  <CustomButton setData={setQuestionDescriptionType} Data={questionDescriptionType} DataValue={item} />
                </div>
              ))}
            </div>
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Question Media </b></td> */}
          <td className="col-4"><b>Media Pertanyaan </b></td>
          <td className="col-7">
            <OptionView
              type={questionMediaType} que={true}
              Data={questionMedia}
              setData={setQuestionMedia}
              placeholderValue={""}
            />
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Question Media Type : </b></td> */}
          <td className="col-4"><b>Tipe Media Pertanyaan : </b></td>
          <td className="col-7">
            <div style={{ display: "inline" }}>
              {type.map((item, index) => (
                <div style={{ display: "inline-block" }} key={index}>
                  <CustomButton setData={setQuestionMediaType} Data={questionMediaType} DataValue={item} />
                </div>
              ))}
            </div>
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Answer Type : </b></td> */}
          <td className="col-4"><b>Tipe Jawaban : </b></td>
          <td className="col-7">
            <div style={{ display: "inline" }}>
              {type.map((item, index) => (
                <div style={{ display: "inline-block" }} key={index}>
                  {item !== "none" &&
                    <CustomButton setData={setAnswerMediaType} Data={answerMediaType} DataValue={item} />
                  }
                </div>
              ))}
              <div style={{ display: "inline-block" }}>
                <CustomButton setData={setAnswerMediaType} Data={answerMediaType} DataValue={{ name: "choose_correct", value: "choose_correct" }} />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Option 1 : </b></td> */}
          <td className="col-4"><b>Pilihan 1 : </b></td>
          <td className="col-7">
            <OptionView
              type={answerMediaType} que={false}
              Data={option1}
              setData={setOption1}
              placeholderValue={"Option 1"}
            />
            {(answerMediaType == "audio" || answerMediaType == "choose_correct") &&
              <div>
                <input className="my-2 px-2 col-12"
                  value={option1Text}
                  onChange={(event) => { setOption1Text(event.target.value) }}
                  placeholder="Option 1 extra"
                />
              </div>
            }
          </td>
        </tr>
        <tr>
          <td className="col-4"><b>Pilihan 2 : </b></td>
          <td className="col-7">
            <OptionView
              type={answerMediaType} que={false}
              Data={option2}
              setData={setOption2}
              placeholderValue={"Option 2"}
            />
            {(answerMediaType == "audio" || answerMediaType == "choose_correct") &&
              <input className="my-2 p-0 px-2 col-12"
                value={option2Text}
                onChange={(event) => { setOption2Text(event.target.value) }}
                placeholder="Option 2 extra"
              />
            }
          </td>
        </tr>
        <tr>
          <td className="col-4"><b>Pilihan 3 : </b></td>
          <td className="col-7">
            <OptionView
              type={answerMediaType} que={false}
              Data={option3}
              setData={setOption3}
              placeholderValue={"Option 3"}
            />
            {(answerMediaType == "audio" || answerMediaType == "choose_correct") &&
              <input className="my-2 p-0 px-2 col-12"
                value={option3Text}
                onChange={(event) => { setOption3Text(event.target.value) }}
                placeholder="Option 3 extra"
              />
            }
          </td>
        </tr>
        <tr>
          <td className="col-4"><b>Pilihan 4 : </b></td>
          <td className="col-7">
            <OptionView
              type={answerMediaType} que={false}
              Data={option4}
              setData={setOption4}
              placeholderValue={"Option 4"}
            />
            {(answerMediaType == "audio" || answerMediaType == "choose_correct") &&
              <input className="my-2 p-0 px-2 col-12"
                value={option4Text}
                onChange={(event) => { setOption4Text(event.target.value) }}
                placeholder="Option 4 extra"
              />
            }
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Correct Answer : </b></td> */}
          <td className="col-4"><b>Jawaban Benar : </b></td>
          <td className="col-7">
            <div style={{ display: "inline" }}>
              {correctAnswerArray.map((item, index) => (
                <div style={{ display: "inline-block" }} key={index}>
                  {item !== "none" &&
                    <CustomButton setData={setCorrectAnswer} Data={correctAnswer} DataValue={item} />
                  }
                </div>
              ))}
            </div>
          </td>
        </tr>
        <tr>
          {/* <td className="col-4"><b>Answer Description : </b></td> */}
          <td className="col-4"><b>Deskripsi Jawaban : </b></td>
          <td className="col-7">
            <textarea cols={3}
              className="p-0 px-2 col-12"
              value={answerDescription}
              onChange={(event) => { setAnswerDescription(event.target.value) }}
              placeholder="Answer Description"
            />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <center>
              <div style={{ width: "30%" }} className="sign-in-button-1"
                onClick={() => {
                  setAllQuestionData({
                    ...AllQuestionData,
                    [keyValue]: {
                      "question_number": questionNumber,
                      "question": question,
                      "question_description": questionDescription,
                      "question_description_type": questionDescriptionType,
                      "question_media": questionMedia,
                      "question_media_type": questionMediaType,
                      "option_1": option1,
                      // "option_2": option2,
                      // "option_3": option3,
                      // "option_4": option4,
                      "option_1_text": option1Text,
                      "option_2": option2,
                      "option_2_text": option2Text,
                      "option_3": option3,
                      "option_3_text": option3Text,
                      "option_4": option4,
                      "option_4_text": option4Text,
                      "answer_description": answerDescription,
                      // "question_text": ListeningPicQuestionText,
                      "correct_answer": correctAnswer,
                      "answer_media_type": answerMediaType,
                    }
                  }
                  )
                  setEditQuestion(false)
                }}
              >
                {/* Done */}
                Selesai
              </div>
            </center>
          </td>
        </tr>
      </table>
    </div>
  )
}
